import type { ReactNode } from 'react'
import { Header } from '@/components/layout/Header'
import { Sidebar } from '@/components/layout/Sidebar'
import { BottomNav } from '@/components/layout/BottomNav'
import { ToastContainer } from '@/components/common/Toast'

interface AppShellProps {
  children: ReactNode
}

const DATE_FORMATTER = new Intl.DateTimeFormat('de-DE', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
})

const BROWSER_TZ = Intl.DateTimeFormat().resolvedOptions().timeZone

export function AppShell({ children }: AppShellProps) {
  const today = DATE_FORMATTER.format(new Date())

  return (
    <div className="flex min-h-screen flex-col bg-void text-ink">
      <Header />

      <div className="flex flex-1">
        <Sidebar />
        <main className="min-w-0 flex-1 overflow-x-hidden px-4 py-6 pb-16 md:overflow-x-visible md:px-8 md:py-8 md:pb-0">
          {children}
        </main>
      </div>

      <footer className="hairline-t hidden h-7 shrink-0 items-center justify-between bg-panel px-6 font-mono text-[10px] uppercase tracking-[0.12em] text-faint md:flex">
        <span>Session · {today}</span>
        <span>{BROWSER_TZ} · v0.1.0</span>
      </footer>

      <BottomNav />
      <ToastContainer />
    </div>
  )
}
